import { createRef, h } from 'preact';
import { APPLICATION_EVENT } from 'constants/events';
import elementClosestPolyfill from 'element-closest';
import { accessible } from 'utilities/accessibility';
import { capitalize } from 'utilities/formatting';
import { ControlsMenu } from './ControlsMenu';
import './level.scss';

elementClosestPolyfill(window);

class Level extends ControlsMenu {
    constructor(props) {
        super(props);
        this.eventBus.on(APPLICATION_EVENT.LEVEL_MENU_OPENED, this.onLevelMenuOpened);
    }

    onLevelMenuOpened = (e) => {
        requestAnimationFrame(() => {
            this.firstMenuItemRef.current.focus();
        });
    }

    get activeOption() {
        const { projectState = {} } = this.props;
        const { level = '' } = projectState;
        return level;
    }

    get availableLevels() {
        const { projectData = {} } = this.props;
        const { levels = [] } = projectData;
        return levels;
    }

    get menuItems() {
        return this.availableLevels;
    }

    changeOption = (level, event) => {
        this.eventBus.emit(APPLICATION_EVENT.LEVEL_CHANGED, level);
        this.allowOverflow(event.target, false);
        this.sendToggleEvent();
        this.menuButtonRef.current.focus();
    };

    formatOption = text => {
        return capitalize(text);
    }

    get menuIsActive() {
        const { menus = {} } = this.props;
        const { showLevelMenu } = menus;
        return showLevelMenu;
    }

    get menuButtonText() {
        const { projectState } = this.props;
        const { level = 'MAX' } = projectState
        return level.toUpperCase();
    }

    render () {
        if (this.availableLevels.length === 0) return null;
        const attrs = {
            name: 'level',
            style: {
                borderLeft: '2px solid #000'
            },
            className: 'level controlBarButton vjs-control vjs-button',
        }

        return (
            /* need to use div instead of button due to IE event capture limitations 😠 */
            <div {...attrs}>
                {this.menuButton}
                {this.menu}
            </div>
        )
    }
}

export {Level};
